import styled from 'helpers/styles';
import {css} from 'styled-components';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import DropdownTableCellEdit from 'components/organisms/TableCellEdits/DropdownTableCellEdit/DropdownTableCellEdit';
import utils from 'helpers/utils';
import FormStyles from 'styles/mixins/Form.styles';

const StyledFieldTableCellEdit = styled(DropdownTableCellEdit)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--field-table-cell-edit-min-width': utils.isDefined(props.$minWidth) ? props.theme.layout(props.$minWidth) : null,
      '--field-table-cell-edit-max-width': utils.isDefined(props.$maxWidth) ? props.theme.layout(props.$maxWidth) : null
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  width: 100%;
  height: 100%;
  
  > .Icon, > .Logo {
    margin-right: ${props => props.theme.layout('1sp')};
  }

  &.FieldTableCellEdit {
    max-width: ${props => props.theme.layout(320)};
    max-height: min(${props => props.theme.layout(300)}, 46vh);

    &:has(.SuggestionField) {
      max-width: unset;
    }
    
    &:has(.TextField-multiline) {
      max-width: ${props => props.theme.layout(500)};
    }

    &:has(.CloudField) {
      max-width: unset;
      overflow: hidden;
    }
    
    ${props => utils.isDefined(props.$minWidth) ? css`
      max-width: unset;
      min-width: ${props.$css.$var('--field-table-cell-edit-min-width', false)} !important;
    ` : css``}

    ${props => utils.isDefined(props.$maxWidth) ? css`
      max-width: ${props.$css.$var('--field-table-cell-edit-max-width', false)} !important;
    ` : css``}
  }
  
  .Form {
    height: 100%;
    padding: ${props => props.theme.spacing(2)};
    &:has(.ListField) {
      padding: ${props => props.theme.spacing(1)} ${props => props.theme.spacing(2)};
    }
    
    .Form-fields {
      height: 100%;
      row-gap: ${props => props.theme.layout('1sp')};
      
      .FormField {
        min-width: ${props => props.theme.layout(244)};
        
        &.ListField {
          &:not(.ListField-showSearch) {
            min-width: unset;
          }
        }

        &.SuggestionField {
          min-width: ${props => props.theme.layout(374)};
          ${props => utils.isDefined(props.$maxWidth) ? css`
            min-width: calc(${props.$css.$var('--field-table-cell-edit-max-width', false)} - ${props.theme.layout('4sp')}) !important;
          ` : css``}
        }

        &.TextField-multiline {
          min-width: ${props => props.theme.layout(374)};
          ${props => utils.isDefined(props.$maxWidth) ? css`
            min-width: calc(${props.$css.$var('--field-table-cell-edit-max-width', false)} - ${props.theme.layout('4sp')}) !important;
          ` : css``}
        }

        &.CloudField {
          max-width: ${props => props.theme.layout(374)};
          min-width: ${props => props.theme.layout(374)};
        }
      }
    }
  }
  
  .MuiFormControl-root {
    max-height: 100%;
    position: relative;
    &.CheckboxField, &.SwitchField {
      min-height: unset;
      
      .FormControlLabel {
        margin-left: ${props => props.theme.layout(-8)};
      }  
      .Checkbox {
        padding: ${props => props.theme.layout(6)};
        svg {
          font-size: ${props => props.theme.fontSize(20)};
        }
      }
      .MuiFormHelperText-root:has(*) {
        bottom: ${props => props.theme.layout(-12)};
      }
    }
    
    .InputContainer {
      max-height: 100%;
    }
    
    .MuiFormHelperText-root:has(*) {
      display: flex;
      width: 100%;
      bottom: ${props => props.theme.layout(-14)};
      height: ${props => props.theme.layout(16)};

      > * {
        width: 1px;
        flex-grow: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        p {
          display: contents;
        }
      }
    }

    .MuiFormHelperText-root:has(.FeedbackHelper) {
      height: unset;
    }
  }
  
  ${FormStyles}
  ${ComponentStyles}
`;

StyledFieldTableCellEdit.propTypes = {
  theme: PropTypes.object
};

export default StyledFieldTableCellEdit;
